module.exports = __webpack_public_path__ + "static/img/publicGuilds.8900eb9b.png";